import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import axios from 'axios';
import qs from 'qs';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import { rescueHtml } from '../../Components/Tools';
import UploadLogoOrganisme from '../../Components/UploadLogoOrganisme';
import UploadTamponSignature from './UploadTamponSignature';
import OrganismeAdresse from '../../Components/OrganismeAdresse';
import OrganismeRib from '../../Components/OrganismeRib';
import OrganismePiedPage from '../../Components/OrganismePiedPage';
import OrganismeCoordonnees from '../../Components/OrganismeCoordonnees';

const Parametres_EPFL = (props) =>
{
    const [budgets, setBudgets] = useState([]);
    const [budget, setBudget] = useState([]);
    const [nomen, setNomen] = useState(null);
    const [organisme, setOrganisme] = useState(null);
    const [phrasesAccueil, setPhrasesAccueil] = useState([]);
    
    const purple = '#6571FE';

    // More robust typewriter effect: uses chained setTimeout and a ref for the index
    const Typewriter = ({ text, speed = 40 }) => {
        const [display, setDisplay] = useState('');
        const indexRef = React.useRef(0);
        const timeoutRef = React.useRef(null);

        useEffect(() => {
            // cleanup any pending timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            if (!text) {
                setDisplay('');
                indexRef.current = 0;
                return;
            }
            setDisplay('');
            indexRef.current = 0;

            const tick = () => {
                const i = indexRef.current;
                if (i >= text.length) {
                    timeoutRef.current = null;
                    return;
                }
                // append the next character
                setDisplay((prev) => prev + text.charAt(i));
                indexRef.current = i + 1;
                timeoutRef.current = setTimeout(tick, speed);
            };

            timeoutRef.current = setTimeout(tick, speed);

            return () => {
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            };
        }, [text, speed]);

        return <span>{display}</span>;
    };

    async function mount()
    {
        if (!props.user) {
            await props.getUser()
        }
        else {
            // Récupération du budget de l'utilisateur
            const params = {
                'getBudgets': true,
                'id': props.user.id_budget
            }
            await axios.post('https://app-slfinance.fr/api/budgets.php', qs.stringify(params))
            .then(async (res) => {
                await setBudget(res.data[0])
            })
            .catch((err) => {
                console.warn(err)
            })
            
            /* Récupération du nomen du budget */
            await axios.get("https://app-slfinance.fr/api/config_budget.php?id_budget="+props.user.id_budget)
            .then(async (res) => {
                await res.data.forEach(async element => {
                    if (element[2] === 'nomen') {
                        var tmp = element[3].split(';');
                        await tmp.pop();
                        await setNomen(tmp);
                    }
                });
            })
            .catch((err) => {
                console.warn(err)
            })

            // Récupération des budgets de l'organisme
            await axios.get("https://app-slfinance.fr/api/budgets.php?id_organisme="+props.user.id_organisme+'&list=true')
            .then(async (result) => {
                var tmp = []
                var i = 1
                await result.data.forEach(async budget => {
                    tmp[i] = {
                        'id_budget': budget.id,
                        'budget_annexe': budget.budget_annexe,
                        'nom': rescueHtml(budget.nom),
                        'siret': budget.siret
                    }
                    i++;
                });
                await setBudgets(tmp);
            })
            .catch((err) => {
                console.warn(err)
            })

            // récuperation des informations de l'organisme
            await axios.post("https://app-slfinance.fr/api/organismes.php", qs.stringify({'getOrganismes': true, 'id': props.user.id_organisme}))
            .then(async (res) => {
                await setOrganisme(res.data);
            })
            .catch((err) => {
                console.warn(err)
            })
            setPhrasesAccueil([
                "Ravi de vous revoir "+rescueHtml(props.user.prenom)+" !",
                "Bienvenue sur Projets & Finances. Gérez vos projets et vos finances en toute simplicité.",
                "Toute la gestion de votre collectivité réunie dans une seule application.",
                "Gérez vos projets et vos finances en toute simplicité avec Projets & Finances.",
                "Projets & Finances, l'application qui simplifie la gestion de votre collectivité.",
                "Avec Projets & Finances, vous pouvez gérer vos projets et vos finances en toute simplicité.",
                "Projets & Finances, l'application qui facilite la gestion de votre collectivité.",
                "Gérez vos projets et vos finances en toute simplicité avec Projets & Finances.",
                "Pilotez vos projets, maîtrisez vos finances et gagnez en efficacité au quotidien.",
                "Bienvenue ! Nous sommes heureux de vous accompagner dans la gestion de votre collectivité.",
                "Prenez les bonnes décisions grâce à une vision claire de vos projets et de vos finances.",
                "Votre partenaire numérique pour une gestion sereine de vos projets et de vos finances."
            ]);
        }
    }

    useEffect(() =>
    {
        mount();
    }, [props.user])


    // Resultat du formulaire
    const { register, handleSubmit } = useForm();
    
    const onSubmit = async data => {
        if (data.id_budget)
        {
            const params = {
                'id': props.user.id,
                'id_budget': data.id_budget,
                'updateUser': true
            };
            axios.post('https://app-slfinance.fr/api/connexion.php', qs.stringify(params))
            .then(() => {
                window.location = window.location.href
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    };


	return (
        <Access needConnection={true}  type_user={[2, 3]}>
            <Navbar user={props.user} />
            {props.user?
            <div>
                <div style={{display: 'flex', margin: 10}}>
                    
                    <div style={{flex: 1}}>
                        <div style={{flex: 1, margin: 20, display: 'flex'}}>
                            <p style={{}}>Paramètre</p>
                            <p style={{marginLeft: 5, color: purple}}>\</p>
                            <p style={{color: purple, fontWeight: 'bold', marginLeft: 5}}>{rescueHtml(props.user.nom_organisme)}</p>
                        </div>
                    </div>
                </div>


                {/* Affichage pour les EPFL */}
                {props.user.id_organisme_type == '4' &&
                <div>

                    <div style={{flex: 1, display: 'flex', justifyContent: 'center', margin: 10, marginTop: 20}}>
                        <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12}}>
                            <UploadLogoOrganisme user={props.user}/>
                        </div>

                        <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12}}>
                            <UploadTamponSignature user={props.user} />
                        </div>
                    </div>

                    <div style={{flex: 1, display: 'flex', margin: 10, marginTop: 20}}>
                        <div style={{flex: 1, margin: 10}}>
                            <OrganismeAdresse budget={budget} user={props.user} />
                        </div>
                    </div>


                    <div style={{flex: 1, display: 'flex', margin: 10, marginTop: 20}}>
                        <div style={{flex: 1, margin: 10}}>
                            <OrganismeCoordonnees user={props.user} />
                        </div>
                    </div>


                    <div style={{flex: 1, display: 'flex', margin: 10, marginTop: 20}}>
                        <div style={{flex: 1, margin: 10}}>
                            <OrganismeRib budget={budget} user={props.user} />
                        </div>
                    </div>

                    <div style={{flex: 1, display: 'flex', margin: 10, marginTop: 20}}>
                        <div style={{flex: 1, margin: 10}}>
                            <OrganismePiedPage user={props.user} />
                        </div>
                    </div>
                </div>
                }
            </div>
            :null}
        </Access>
	);
}

export default Parametres_EPFL;
